/** Chaves do TanStack Query centralizadas — facilita invalidar o cache depois de mutações. */
export const qk = {
  me: ['auth', 'me'] as const,
  dashboard: ['dashboard'] as const,
  clients: {
    all: ['clients'] as const,
    list: (params: object) => ['clients', 'list', params] as const,
    detail: (id: string) => ['clients', 'detail', id] as const,
    equipment: (id: string) => ['clients', 'detail', id, 'equipment'] as const,
    orders: (id: string) => ['clients', 'detail', id, 'orders'] as const,
    maintenance: (id: string) => ['clients', 'detail', id, 'maintenance'] as const,
  },
  categories: { all: ['categories'] as const, list: (includeInactive: boolean) => ['categories', 'list', includeInactive] as const },
  equipment: {
    all: ['equipment'] as const,
    list: (params: object) => ['equipment', 'list', params] as const,
    history: (id: string) => ['equipment', 'history', id] as const,
  },
  orders: {
    all: ['orders'] as const,
    list: (params: object) => ['orders', 'list', params] as const,
    bench: ['orders', 'bench'] as const,
    detail: (id: string) => ['orders', 'detail', id] as const,
    print: (id: string, secrets: boolean) => ['orders', 'print', id, secrets] as const,
    checklist: (id: string) => ['orders', 'checklist', id] as const,
    signature: (id: string) => ['orders', 'signature', id] as const,
    components: (id: string) => ['orders', 'components', id] as const,
  },
  products: { all: ['products'] as const, list: (params: object) => ['products', 'list', params] as const },
  catalogRefs: {
    all: ['catalog-references'] as const,
    list: (kind: string, includeInactive: boolean) => ['catalog-references', kind, includeInactive] as const,
  },
  stockReceipts: { all: ['stock-receipts'] as const, list: (params: object) => ['stock-receipts', 'list', params] as const },
  expenses: { all: ['expenses'] as const, list: (params: object) => ['expenses', 'list', params] as const },
  components: { all: ['components'] as const, list: (params: object) => ['components', 'list', params] as const },
  componentTypes: { all: ['component-types'] as const, list: (includeInactive: boolean) => ['component-types', 'list', includeInactive] as const },
  stock: {
    overview: ['stock', 'overview'] as const,
    movements: (kind: string, id: string) => ['stock', kind, id, 'movements'] as const,
  },
  finance: {
    all: ['finance'] as const,
    overview: (month: string) => ['finance', 'overview', month] as const,
    receivables: ['finance', 'receivables'] as const,
  },
  services: { all: ['services'] as const, list: (params: object) => ['services', 'list', params] as const },
  users: { all: ['users'] as const, technicians: ['users', 'technicians'] as const },
  settings: ['settings', 'company'] as const,
};
